import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api } from "../lib/api";
import { Logo } from "../components/Brand";

const nextFor = (item) => (item === "membership" ? ["/app/academy", "Go to the Academy"] : [`/app/learn/${item}`, "Start learning"]);

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [st, setSt] = useState(cancelled ? { payment_status: "cancelled", item: params.get("item") } : null);

  useEffect(() => {
    if (cancelled || !sid) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setSt(data);
        if (data.payment_status === "paid" || data.status === "expired" || ++tries >= 15) return;
      } catch { if (++tries >= 15) return setSt({ payment_status: "error" }); }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, cancelled]);

  const paid = st?.payment_status === "paid";
  const waiting = !st || (!paid && !["cancelled", "expired", "error", "failed"].includes(st.payment_status) && st.status !== "expired");
  const [to, label] = paid ? nextFor(st.item) : ["/app/academy", "Back to the Academy"];

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#FAF8FC]">
      <div className="dx-card p-8 max-w-md w-full text-center" data-testid="payment-result">
        <div className="flex justify-center mb-6"><Logo /></div>
        {waiting ? (
          <><Loader2 className="w-10 h-10 animate-spin mx-auto text-[#5B2A6E]" /><h1 className="font-display text-2xl font-bold mt-4" data-testid="payment-result-title">Confirming your payment…</h1><p className="text-sm text-[#6b5a73] mt-2">This only takes a few seconds.</p></>
        ) : paid ? (
          <><CheckCircle2 className="w-12 h-12 mx-auto text-emerald-600" /><h1 className="font-display text-2xl font-bold mt-4" data-testid="payment-result-title">Payment successful</h1><p className="text-sm text-[#6b5a73] mt-2">{st.item === "membership" ? "Your membership is active - you can now upload your resume and enrol in belts." : "You're enrolled. Your first session is ready."}</p></>
        ) : (
          <><XCircle className="w-12 h-12 mx-auto text-rose-500" /><h1 className="font-display text-2xl font-bold mt-4" data-testid="payment-result-title">{st.payment_status === "cancelled" ? "Payment cancelled" : "Payment not completed"}</h1><p className="text-sm text-[#6b5a73] mt-2">No money was taken. You can try again any time.</p></>
        )}
        {!waiting && <Link to={to} className="dx-btn-gold mt-6 inline-flex" data-testid="payment-result-continue-btn">{label}</Link>}
      </div>
    </div>
  );
}
